<template>
  <DefaultLayout class="IntegrationView">
    <h1 class="mb-4 display-1">
      Интеграции
    </h1>

    <VRow v-if="authorized">
      <VCol>
        <IntegrationCard
          code="bitrix24"
          logo-alt="Логотип Битрикс24"
          :logo-src="require('../assets/bitrix24-logo.svg')"
          logo-contain
          sync-text="Синхронизировано с Битрикс24"
        />
      </VCol>
      <VCol>
        <IntegrationPlaceHolderCard
          :logo-src="require('../assets/amocrm-logo-white.png')"
          logo-alt="Логотип amoCRM"
          news-href="https://it-solution.ru/articles/"
        />
      </VCol>
      <VCol>
        <IntegrationPlaceHolderCard
          :logo-src="require('../assets/logo1c.png')"
          logo-href="https://it-solution.ru/1c-solution/"
          logo-alt="Логотип 1С"
          news-href="https://it-solution.ru/articles/"
          logo-max-width="100px"
          logo-height="50px"
        />
      </VCol>
    </VRow>
    <VAlert
      v-else
      border="left"
      outlined
      color="primary"
      icon="mdi-account-circle"
    >
      Для просмотра интеграций
      <VBtn
        text
        small
        color="primary"
        @click="$store.commit('ui/setLoginModal', { value: true })"
      >
        авторизоваться
      </VBtn>
    </VAlert>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../layouts/Default'
import IntegrationPlaceHolderCard from '../components/IntegrationPlaceholderCard'
import IntegrationCard from '../components/IntegrationCard'

export default {
  name: 'Integration',
  components: {
    IntegrationCard,
    IntegrationPlaceHolderCard,
    DefaultLayout,
  },
  computed: {
    authorized() { return !!this.$store.state.auth.token },
  },
  watch: {
    authorized: {
      handler(authorized) {
        if (authorized) this.$store.dispatch('integration/get')
      },
      immediate: true,
    },
  },
}
</script>
